/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type PostTextMd5Request = { text: string };

export const PostTextMd5Request$zodSchema: z.ZodType<PostTextMd5Request> = z
  .object({
    text: z.string(),
  });

export type PostTextMd5Details = {};

export const PostTextMd5Details$zodSchema: z.ZodType<PostTextMd5Details> = z
  .object({});

/**
 * 缺少text参数
 */
export type PostTextMd5BadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTextMd5Details | undefined;
  message?: string | undefined;
};

export const PostTextMd5BadRequestResponseBody$zodSchema: z.ZodType<
  PostTextMd5BadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTextMd5Details$zodSchema).optional(),
  message: z.string().optional(),
}).describe("缺少text参数");

/**
 * 成功响应
 */
export type PostTextMd5ResponseBody = { md5?: string | undefined };

export const PostTextMd5ResponseBody$zodSchema: z.ZodType<
  PostTextMd5ResponseBody
> = z.object({
  md5: z.string().optional(),
}).describe("成功响应");

export type PostTextMd5Response =
  | PostTextMd5ResponseBody
  | PostTextMd5BadRequestResponseBody;

export const PostTextMd5Response$zodSchema: z.ZodType<PostTextMd5Response> = z
  .union([
    z.lazy(() => PostTextMd5ResponseBody$zodSchema),
    z.lazy(() => PostTextMd5BadRequestResponseBody$zodSchema),
  ]);
